<template>
    <div class="px-md-0 col-12">
        <ul class="breadcrumb-list container mx-md-3 mx-xl-auto row" aria-label="パンくずリスト">
            <li>
                <router-link tabindex="0" :to="{name: 'Top'}" :aria-label="$t('breadcrumbs.top')">
                    <span class="step">{{ $t('buttons.top') }}</span>
                </router-link>
            </li>
            <li>
                <span tabindex="0" aria-current="page">{{ $t('buttons.accessibility') }}</span>
            </li>
        </ul>
        <div class="container text-center">
            <h1 class="title heading-01" id="contents-area"><span tabindex="0">{{ $t('buttons.accessibility') }}</span></h1>
        </div>
        <div class="px-0">
            <div class="accessibility">
                <div v-html="$t('staticPages.Accessibility')"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Accessibility",
        metaInfo: function() {
            return {
                // TODO 問い合わせの言語変数が出来次第差し替える
                title: this.$t('buttons.accessibility'),
                titleTemplate: `%s | ${this.$t('siteInfo.title')}`,
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut',
                    },
                    {
                        vmid: 'og-title',
                        property: 'og:title',
                        content: this.$t('buttons.accessibility'),
                    },
                    {
                        vmid: 'og-description',
                        property: 'og:description',
                        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut',
                    }
                ]
            }
        }
    }
</script>

<style src="./Accessibility.scss" lang="scss" scoped />
